"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
"use strict";
const moment_1 = __importDefault(require("moment"));
const v4_1 = __importDefault(require("uuid/v4"));
const __1 = require("..");
class Installation extends __1.OMObject {
    constructor(object) {
        super(object);
        this.device = object.device;
        this.identifier = object.identifier;
        this.snsEndpointArn = object.snsEndpointArn;
        this.pushToken = object.pushToken;
        this.lastLaunchedAt = moment_1.default(object.lastLaunchedAt);
        this.user = object.user && new __1.OMReference(__1.OMUser, object.user);
        this.app = object.app && new __1.OMReference(__1.Application, object.app);
    }
    static FromUser(user) {
        const installationProperties = {
            device: (() => {
                try {
                    return navigator.userAgent;
                }
                catch (e) {
                    return global.process.version;
                }
            })(),
            identifier: v4_1.default(),
            lastLaunchedAt: moment_1.default(),
            permissions: 777,
        };
        return new Installation(installationProperties);
    }
    // tslint:disable-next-line
    static analyze(startDate, endDate) {
        try {
            const command = new Installation.AnalyzeCommand(Installation, startDate, endDate);
            return __1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    toJSON() {
        return Object.assign({}, this, {
            ownerUuid: undefined,
        });
    }
}
Installation.Path = "installations";
Installation.Type = "installation";
Installation.AnalyzeCommand = (_a = class AnalyzeCommand extends __1.Command {
        constructor(receiver, startDate, endDate) {
            super(receiver);
            this.startDate = startDate;
            this.endDate = endDate;
        }
    },
    _a.Path = "analyze",
    _a);
exports.default = Installation;
//# sourceMappingURL=Installation.js.map